import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Typography from "material-ui/Typography";
import Checkbox from "material-ui/Checkbox";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import CheckBoxOutlineBlankIcon from "material-ui-icons/CheckBoxOutlineBlank";

import Profiles from "../data/Profiles.json";
import getProfile from "../utils/getProfile";
import { setSelectedIndex } from "../actions/quizResult";

function breakLine(text) {
  const br = React.createElement("br");
  const regex = /(<br \/>)/g;
  return text.split(regex).map(function(line, index) {
    return line.match(regex) ? <br key={"key_" + index} /> : line;
  });
}

function SustainableFocus({ profile, selectedIndex, onCheck }) {
  if (!Profiles.sustainableFocus[profile]) {
    return "The following profile doens't exist yet: " + profile;
  }

  return Profiles.sustainableFocus[profile].map((lens, index) => (
    <span key={"lens_" + index}>
      <Checkbox
        icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 18 }} />}
        disabled={selectedIndex !== index && selectedIndex !== -1}
        name="challenge"
        checked={selectedIndex === index}
        color="primary"
        onChange={() => onCheck(index)}
      />
      <div className="lens-text">{lens}</div>
    </span>
  ));
}

function QuizFinishView(props) {
  const profile = getProfile(props.quiz.questions);

  let sProfileText_text_title_1 = "";
  let sProfileText_text_title_2 = "";

  sProfileText_text_title_1 = breakLine(
    Profiles.profiles[profile].text_title_1
  );
  sProfileText_text_title_2 = breakLine(
    Profiles.profiles[profile].text_title_2
  );

  const title_purple = {
    color: "#8146af",
    fontWeight: "bold",
    fontSize: "1.5em",
    marginTop: "30px"
  };
  const title_darkblue = {
    color: "#0b2440",
    fontWeight: "bold",
    fontSize: "0.8em"
  };

  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Typography
              component="div"
              style={{
                margin: "20px 20px 0px 20px",
                textAlign: "left",
                fontWeight: "lighter"
              }}
            >
              <span style={title_purple}>
                <span>{sProfileText_text_title_1}</span>
                <span style={title_darkblue}>{sProfileText_text_title_2}</span>
                <br />
              </span>
            </Typography>
            <Typography
              variant="headline"
              style={{
                fontSize: "18px",
                margin: "-20px 15px ",
                textAlign: "left"
              }}
            >
              Choose your sustainable personal development point for the coming month
            </Typography>
            <Typography
              component="p"
              style={{
                margin: "15px",
                textAlign: "left"
              }}
            >
              <SustainableFocus
                profile={profile.slice(1, 3)}
                selectedIndex={props.quizResult.selectedIndex}
                onCheck={props.setSelectedIndex}
              />
            </Typography>
            <Link to={"/interested"}>
              <Button
                variant="raised"
                style={{ marginBottom: "20px" }}
                color="primary"
              >
                Next
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default connect(
  ({ quiz, quizResult }) => ({ quiz, quizResult }),
  dispatch => bindActionCreators({ setSelectedIndex }, dispatch)
)(QuizFinishView);



// WEBPACK FOOTER //
// ./src/views/QuizFinishView.jsx